export default {"src":"/_next/static/media/Twitter.2f855012.svg","height":29,"width":30,"blurWidth":0,"blurHeight":0};